import React, { useRef, useEffect, useState, useCallback, useContext } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss';

import '../layout/sass/_responsiveTable.scss';
import { confirmDialog } from 'primereact/confirmdialog';
import api from '../api/api';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

export const TabelaPessoa = () => {
    const history = useHistory();
    const toast = useRef(null);
    const { user } = useContext(AuthContext);
    const [pessoas, setPessoas] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const confirmationToast = useRef(null);
    const [sortable, setSortable] = useState('ASC');
    const [first, setFirst] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [sortableCampo, setSortableCampo] = useState('nome');
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        sortField: null,
        sortOrder: null,
        filters: {
            'id': { value: "", matchMode: 'contains' },
            'nome': { value: "", matchMode: 'contains' },
            'cpf': { value: "", matchMode: 'contains' },
            'email': { value: "", matchMode: 'contains' },
            'numero_instalacao': { value: "", matchMode: 'contains' },
        }
    });

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Pessoas</h2>
            </div>
        </div>
    );

    function desformat(data) {
        return data.replace(/[\D]/g, "");
    }
    
    function formatCpf(data) {
        const cpf = data.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
        return cpf;
    }

    const getPessoas = useCallback(async (event) => {
        setIsLoading(true);
        setPessoas([]);

        if (event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;
                setFirst(startIndex);
            }, 250);
        }

        try {
            if (lazyParams.filters === undefined) {

                if (event === undefined) {
                    const response = await api.get(`pessoa?sort=${sortableCampo},${sortable}`);
                    
                    response.data.content.forEach(pessoa => {
                        setPessoas(pessoas => [...pessoas, pessoa]);
                    });
                } else {
                    const response = await api.get(`pessoa?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(pessoa => {
                        setPessoas(pessoas => [...pessoas, pessoa]);
                    });
                }

                const respElements = await api.get(`pessoa?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            } else {
                const pesquisa = {
                    "id": lazyParams.filters['id'] !== undefined ? lazyParams.filters['id'].value : null,
                    "nome": lazyParams.filters['nome'] !== undefined ? lazyParams.filters['nome'].value : "",
                    "cpf": lazyParams.filters['cpf'] !== undefined ? desformat(lazyParams.filters['cpf'].value) : "",
                    "email": lazyParams.filters['email'] !== undefined ? lazyParams.filters['email'].value : "",
                    "numero_instalacao": lazyParams.filters['numero_instalacao'] !== undefined ? lazyParams.filters['numero_instalacao'].value : "",
                };

                if (event === undefined) {  
                    const respElements = await api.post(`pessoa/searchPessoa/${sortable}/${sortableCampo}?`, pesquisa);
                    respElements.data.content.forEach(pessoa => {
                        setPessoas(pessoas => [...pessoas, pessoa]);
                    });
                    setTotalRecords(respElements.data.totalElements);
                } else {
                    const respElements = await api.post(`pessoa/searchPessoa/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                    respElements.data.content.forEach(pessoa => {
                        setPessoas(pessoas => [...pessoas, pessoa]);
                    });
                    setTotalRecords(respElements.data.totalElements);
                }
            }
        }
        catch (error) {
            if (lazyParams !== undefined) {
                if (event === undefined) {
                    const response = await api.get(`pessoa?sort=nome,${sortable}`);
                    response.data.content.forEach(pessoa => {
                        setPessoas(pessoas => [...pessoas, pessoa]);
                    });
                } else {
                    const response = await api.get(`pessoa?page=${event.page}&sort=nome,${sortable}`);
                    response.data.content.forEach(pessoa => {
                        setPessoas(pessoas => [...pessoas, pessoa]);
                    });
                }

                const respElements = await api.get(`pessoa?sort=id,${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter pessoas', detail: error.toString() });
            }
        }

        setIsLoading(false);
    }, [lazyParams, sortable, sortableCampo]);

    useEffect(() => {
        const fetchpessoas = async () => {
            try {
                await getPessoas();                
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        };
        fetchpessoas();

    }, [getPessoas]);

    const idBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    };

    const nomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome</span>
                    <span className="table-data">{rowData.nome ? rowData.nome.toUpperCase() : ''}</span>
                </p>
            </React.Fragment>
        );
    };

    const cpfBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">CPF</span>
                    <span className="table-data">{rowData.cpf ? formatCpf(rowData.cpf) : rowData.cpf}</span>
                </p>
            </React.Fragment>
        );
    };

    const emailBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">E-mail</span>
                    <span className="table-data">{rowData.email}</span>
                </p>
            </React.Fragment>
        );
    };

    const numeroInstalacaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nº Instalação</span>
                    <span className="table-data">{rowData.numero_instalacao}</span>
                </p>
            </React.Fragment>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-mr-2 edit-btn" onClick={() => handleEditClick(rowData)} />
            </div>
        );
    };

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if (sortable === 'ASC') {
            setSortable('DESC');
        } else if (sortable === 'DESC') {
            setSortable('ASC');
        }
    };

    const handleEditClick = (data) => {
        history.push(`/pessoa/edit/${data.id}`);
    };

    const handleDeleteClick = (data) => {
        data['userEmail'] = user.email;

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {
                    await api.delete(`pessoa/${data.id}`);
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `${data.nome} removido(a) com sucesso` });
                    getPessoas();
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover a pessoa', detail: error.response?.data || error.toString() });
                }

                setIsDeleting(false);
            },
            reject: () => { return; }
        });
    };

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    };

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <Toast ref={confirmationToast} position="bottom-center" />
                
                <div className="card p-col-12 datatable-responsive-demo">
                    <div className="p-fluid">
                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getPessoas}
                            header={header}
                            value={pessoas}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhuma pessoa encontrada"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} pessoas`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            rowsPerPageOptions={[20, 100]}
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={lazyParams.filters}
                        >
                            <Column
                                field="id"
                                header="Código"
                                sortable
                                body={idBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Código"
                            />

                            <Column
                                field="nome"
                                header="Nome"
                                sortable
                                body={nomeBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Nome"
                            />

                            <Column
                                field="cpf"
                                header="CPF"
                                sortable
                                body={cpfBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por CPF"
                            />

                            <Column
                                field="email"
                                header="E-mail"
                                sortable
                                body={emailBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por E-mail"
                            />

                            <Column
                                field="numero_instalacao"
                                header="Nº da Instalação"
                                sortable
                                body={numeroInstalacaoBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar pelo Nº da instalação"
                            />

                            <Column
                                header="Ações"
                                body={actionBodyTemplate}
                            />
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
};